
import {Chat} from 'stores/chats'
import ChatV1 from './chat-v1.vue'
import ChatV2 from './chat-v2.vue'

export default {
  components: {ChatV1, ChatV2},
  props: {
    chat: {
      type: Chat,
      required: true
    }
  }
}
